export default __webpack_public_path__ + "static/media/lds-logo_hr.8d19b827f49932e3.svg";